import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';
import { ResetStateAction } from 'services/auth/types';
import { TIMESHEET_HOLIDAYS_SET, TIMESHEET_HOLIDAY_SET } from './constants';
import { TimesheetHolidaysState, TimesheetHolidaysActions } from './types';

const initialState: TimesheetHolidaysState = {};

export default function (
    state: TimesheetHolidaysState = initialState,
    action: TimesheetHolidaysActions | ResetStateAction
): TimesheetHolidaysState {
    switch (action.type) {
        case TIMESHEET_HOLIDAYS_SET:
            return get(action, 'payload', {});
        case TIMESHEET_HOLIDAY_SET:
            return {
                ...state,
                ...get(action, 'payload', {})
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
